export const translations = {
  nl: {
    nav: {
      services: "Diensten",
      audit: "Website scan",
      nachtrust: "Nachtrust",
      support: "Support",
      journal: "Blogs & Tips",
      contact: "Contact",
      cta: "Scan je Website",
    },
    hero: {
      overline: "Digital Agency · Lemmer, NL",
      title_a: "Website.",
      title_b: "Marketing.",
      title_c: "Automations.",
      title_d: "Geregeld.",
      promise: "Geregeld is geregeld. Wat ik beloof, staat in cijfers in je offerte. Haal ik het niet, dan werk ik door tot het er staat. Zonder extra rekening.",
      sub: "Van de winkel om de hoek tot een platform met ruim 100.000 bezoekers per kwartaal. Eén vakman, twintig jaar ervaring, AI als rechterhand.",
      rotating: [
        "Hoor je niets van mij, dan gaat het goed.",
        "Eén aanspreekpunt, van code tot advertentie.",
        "Negen klanten zijn al meer dan tien jaar bij me.",
      ],
      cta_primary: "Laat mij je site bekijken",
      cta_secondary: "Bekijk werk",
      meta: "Gevestigd in Lemmer · Werkend internationaal",
    },
    marquee: [
      "Website",
      "SEO",
      "AEO",
      "Meta Ads",
      "WordPress Onderhoud",
      "Conversie",
      "Automations",
    ],
    services: {
      overline: "Diensten",
      title: "Vier pijlers. Eén funnel.",
      sub: "Losse diensten leveren losse resultaten. Wij bundelen web, organisch, AI-vindbaarheid en paid in één strategisch geheel.",
      items: [
        {
          tag: "01",
          name: "Website",
          desc: "Conversie-gerichte websites die je verhaal vertellen en je pijplijn vullen. Headless, razendsnel, perfect scorend op Core Web Vitals.",
          points: ["Strategie & UX", "Design system", "Build & launch", "A/B-testen"],
        },
        {
          tag: "02",
          name: "SEO",
          desc: "Technisch, content en linkbuilding. Gestructureerd werken aan posities die blijven staan — niet in een maand, wel voor jaren.",
          points: ["Audit & roadmap", "Content clusters", "Technical SEO", "Rapportage"],
        },
        {
          tag: "03",
          name: "AEO",
          desc: "Answer Engine Optimization. We zorgen dat ChatGPT, Perplexity en Google AI Overviews jóu citeren, niet je concurrent.",
          points: ["Schema.org & entiteiten", "LLM-readability", "FAQ-stacks", "Answer-first content"],
        },
        {
          tag: "04",
          name: "Meta Ads",
          desc: "Facebook & Instagram ads die schalen. Creative-first, data-driven, volledig attributie-proof.",
          points: ["Creative productie", "Funnel setup", "Pixel & CAPI", "Wekelijkse optimalisatie"],
        },
      ],
    },
    audit: {
      overline: "Gratis AI-scan",
      title: "Scan je site in ongeveer een minuut.",
      sub: "Voer een URL in. Ik lees je pagina zoals een browser hem krijgt, Google PageSpeed meet de snelheid en Claude van Anthropic legt de uitkomst uit. Je krijgt een persoonlijk rapport.",
      placeholder: "jouwdomein.nl",
      btn: "Analyseer mijn site",
      loading_steps: [
        "Je pagina ophalen…",
        "robots.txt, sitemap en menu-pagina's lezen…",
        "Snelheid meten met Google PageSpeed…",
        "Schema en AEO-signalen controleren…",
        "Claude van Anthropic schrijft je rapport…",
      ],
      result: {
        overall: "Totaalscore",
        seo: "SEO",
        aeo: "AEO",
        performance: "Performance",
        findings: "Bevindingen",
        recommendations: "Aanbevelingen",
        aeo_ops: "AEO-kansen",
        cta: "Plan een gesprek met Ghio",
        new: "Nieuwe scan starten",
        measured: "gemeten",
        not_measured: "niet gemeten",
        unreadable_title: "Ik kon je site niet lezen.",
        speed_only: "Wat ik wel kon meten: snelheid",
        working: "Claude van Anthropic aan het werk",
      },
      severity: {
        critical: "Kritiek",
        warning: "Let op",
        ok: "In orde",
      },
      name_label: "Je naam (optioneel)",
      email_label: "E-mail voor het rapport (optioneel)",
      toast_complete: "Scan compleet",
      toast_failed: "Scan mislukt",
    },
    quiz: {
      overline: "Kwalificatie",
      title: "Welke funnel past bij jou?",
      sub: "Vijf korte vragen. Aan het eind ontvang je een persoonlijk advies.",
      start: "Start de quiz",
      next: "Volgende",
      back: "Terug",
      submit: "Ontvang mijn advies",
      step: "Stap",
      of: "van",
      questions: [
        {
          id: "goal",
          q: "Wat is je belangrijkste doel voor de komende 6 maanden?",
          options: [
            "Meer kwalitatieve leads",
            "Hogere omzet per klant",
            "Meer zichtbaarheid in AI-zoekers",
            "Een compleet nieuwe website",
          ],
        },
        {
          id: "stage",
          q: "Waar sta je nu?",
          options: [
            "Starter — net begonnen",
            "Groeiend — eerste klanten binnen",
            "Gevestigd — klaar om te schalen",
            "Enterprise — optimalisatie nodig",
          ],
        },
        {
          id: "budget",
          q: "Indicatief maandbudget voor marketing & web?",
          options: [
            "< €1.000",
            "€1.000 – €3.000",
            "€3.000 – €7.500",
            "€7.500+",
          ],
        },
        {
          id: "pain",
          q: "Wat is je grootste pijnpunt op dit moment?",
          options: [
            "Geen leads vanuit de website",
            "Site is traag of verouderd",
            "Onvindbaar in ChatGPT / AI",
            "Ad-kosten lopen uit de hand",
          ],
        },
        {
          id: "timing",
          q: "Wanneer wil je starten?",
          options: ["Zo snel mogelijk", "Binnen 1 maand", "Binnen 3 maanden", "Oriënterend"],
        },
      ],
      form_title: "Laat je gegevens achter",
      form_sub: "We sturen je binnen 24 uur een persoonlijk advies.",
      name: "Naam",
      email: "E-mail",
      company: "Bedrijf",
      phone: "Telefoon",
      success_title: "Dank je wel.",
      success_sub: "Je advies ligt binnen 24 uur in je inbox. Geen spam, beloofd.",
      toast_sent: "Verstuurd",
      toast_error: "Er ging iets mis.",
    },
    nachtrust: {
      overline: "Nachtrust · Onderhoud, hosting en bewaking",
      title: "Hoor je niets van mij, dan gaat het goed.",
      sub: "Updates, back-ups, beveiliging en bewaking. Elke dag, elke nacht. Gaat er iets mis, dan los ik het op voordat jij het merkt. Voor WordPress én voor de systemen die ik zelf bouw.",
      tiers: [
        {
          name: "Basic",
          price: "€49",
          cycle: "/mnd",
          desc: "Rust voor een gewone bedrijfssite.",
          features: [
            "Wekelijkse core & plugin updates",
            "Dagelijkse offsite backup",
            "Uptime monitoring 24/7",
            "Maandrapport",
          ],
          cta: "Kies Basic",
          highlight: false,
        },
        {
          name: "Pro",
          price: "€99",
          cycle: "/mnd",
          desc: "De sweet spot voor groeiende merken.",
          features: [
            "Alles uit Basic",
            "Security hardening & malware scan",
            "Performance tuning & caching",
            "1/2 uur content-/dev-werk per maand",
            "Prioriteit support binnen 4 uur",
          ],
          cta: "Kies Pro",
          highlight: true,
          badge: "Meest gekozen",
        },
        {
          name: "Premium",
          price: "€199",
          cycle: "/mnd",
          desc: "Voor sites waar elke minuut telt.",
          features: [
            "Alles uit Pro",
            "Staging omgeving & deploy workflow",
            "1 uur content-/dev-werk per maand",
            "Maandelijkse strategie-call",
            "Support binnen 1 uur, 24/7",
          ],
          cta: "Kies Premium",
          highlight: false,
        },
      ],
      guarantee: "Geen contract, maandelijks opzegbaar. Minstens 23 klanten zijn al langer dan vijf jaar bij me.",
    },
    work: {
      overline: "Werk",
      title: "Resultaat dat je kunt zien.",
      items: [
        {
          slug: "ten-wolde-tools",
          client: "Ten Wolde Tools",
          metric: "Duizenden €",
          label: "per jaar aan platformkosten bespaard",
          detail: "Eigen webshop met 35.000+ producten, gekoppeld aan leveranciers en kassa",
        },
        {
          slug: "helza-hobbyzaden",
          client: "Helza Hobbyzaden",
          metric: "20 dagen",
          label: "van opdracht tot live, vóór het zaaiseizoen",
          detail: "Zadenshop in 3 talen, zonder pluginkosten",
        },
        {
          slug: "lemmer-leeft",
          client: "Lemmer Leeft",
          metric: "129",
          label: "ondernemers zichtbaar voor bezoekers",
          detail: "Bezoekersportaal in 3 talen, de BIZ beheert het zelf",
        },
        {
          slug: "power-academy",
          client: "Power Academy",
          metric: "3 → 1",
          label: "site, kassa en ledensite worden één platform",
          detail: "Nu in aanbouw",
          badge: "In aanbouw",
        },
      ],
      visit: "Bekijk project",
    },
    about: {
      overline: "Over Ghio",
      title: "Ondernemer. Bouwer. Eén aanspreekpunt.",
      body: [
        "Ik ben Ghio Coste. Ik bouw al twintig jaar websites, webshops en platforms. En ik heb zelf een sportstudio in Lemmer, met leden en campagnes. Ik weet dus hoe het voelt als de site plat ligt op zaterdag.",
        "Daarom bouw ik wat ik zelf zou willen hebben: een systeem dat precies doet wat jouw bedrijf nodig heeft. Daarna houd ik het in de gaten.",
        "Met AI als rechterhand doe ik alleen wat vroeger een heel team kostte. Ik controleer alles zelf, en ik sta ervoor in. Jij praat met één persoon, van de eerste schets tot de laatste advertentie.",
        "Klein of groot. Een winkel in Lemmer, een zadenshop in drie talen, of een platform met ruim 100.000 bezoekers per kwartaal.",
      ],
      stats: [
        { k: "20+", v: "jaar ervaring" },
        { k: "280+", v: "projecten live" },
        { k: "23", v: "klanten langer dan 5 jaar bij me" },
        { k: "4.9", v: "score uit reviews", href: "https://www.trustindex.io/reviews/ghio.nl" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Laten we praten.",
      sub: "Een idee, een briefing of gewoon een koffie. Wij reageren binnen één werkdag.",
      name: "Naam",
      email: "E-mail",
      phone: "Telefoon",
      company: "Bedrijf",
      message: "Vertel ons over je project",
      submit: "Verstuur bericht",
      sending: "Versturen…",
      success: "Verstuurd. We nemen snel contact op.",
      error: "Er ging iets mis. Probeer het later opnieuw.",
    },
    footer: {
      tagline: "Website. Marketing. Automations. Geregeld.",
      office: "Kantoor",
      contact: "Contact",
      legal: "Juridisch",
      kvk: "KvK 42040800",
      rights: "Alle rechten voorbehouden.",
    },
    common: {
      close: "Sluiten",
    },
    support: {
      overline: "Support op afstand",
      title: "We kijken even mee.",
      sub: "Met TeamViewer QuickSupport verbinden we kort en veilig met je computer — alleen op jouw uitnodiging, en jij kunt op elk moment de sessie sluiten.",
      step_overline: "Drie stappen",
      step1_title: "Download QuickSupport",
      step1_body: "Klik hieronder op de knop voor jouw systeem. Het tooltje is licht (~10 MB) en hoeft niet geïnstalleerd — het start meteen.",
      step2_title: "Open het bestand",
      step2_body: "Je ziet een ID en een wachtwoord verschijnen. Niets meer doen — wacht op onze oproep.",
      step3_title: "Bel of mail ons",
      step3_body: "Geef ons je ID en wachtwoord door en we maken contact. Zodra je de sessie sluit, is de verbinding weg.",
      download_overline: "Download",
      download_recommended: "Aanbevolen voor jouw systeem",
      download_windows: "Windows · QuickSupport (.exe)",
      download_mac: "macOS · QuickSupport (.dmg)",
      download_mobile: "iOS / Android · App Store",
      download_other: "Ander systeem? Open teamviewer.com",
      contact_overline: "Bel ons direct",
      contact_call: "Bel +31 6 53 73 18 19",
      contact_email: "Of mail info@ghio.nl",
      privacy_title: "Veilig en transparant",
      privacy_body: "Je deelt zelf je ID. Wij zien niets zonder je goedkeuring. Sessies worden niet opgenomen tenzij je daar zelf om vraagt. Sluit het venster en de verbinding is direct verbroken.",
    },
  },

  en: {
    nav: {
      services: "Services",
      audit: "Website scan",
      nachtrust: "Maintenance",
      support: "Support",
      journal: "Blogs & Tips",
      contact: "Contact",
      cta: "Scan your Website",
    },
    hero: {
      overline: "Digital Agency · Lemmer, NL",
      title_a: "Website.",
      title_b: "Marketing.",
      title_c: "Automations.",
      title_d: "Handled.",
      promise: "Handled means handled. What I promise is written in numbers in your quote. If I don't reach it, I keep working until it's there. No extra bill.",
      sub: "From the shop around the corner to a platform with over 100,000 visitors a quarter. One craftsman, twenty years of experience, AI as my right hand.",
      rotating: [
        "If you don't hear from me, all is well.",
        "One point of contact, from code to ad.",
        "Nine clients have been with me for more than ten years.",
      ],
      cta_primary: "Let me look at your site",
      cta_secondary: "See work",
      meta: "Based in Lemmer · Working internationally",
    },
    marquee: [
      "Websites",
      "SEO",
      "AEO",
      "Meta Ads",
      "WordPress Maintenance",
      "Conversion",
      "Automations",
    ],
    services: {
      overline: "Services",
      title: "Four pillars. One funnel.",
      sub: "Disconnected services deliver disconnected results. We bundle web, organic, AI-visibility and paid into one strategic whole.",
      items: [
        {
          tag: "01",
          name: "Website",
          desc: "Conversion-driven sites that tell your story and fill your pipeline. Headless, fast, perfect Core Web Vitals.",
          points: ["Strategy & UX", "Design system", "Build & launch", "A/B testing"],
        },
        {
          tag: "02",
          name: "SEO",
          desc: "Technical, content, and link building. Systematic work toward rankings that stick — not for a month, but for years.",
          points: ["Audit & roadmap", "Content clusters", "Technical SEO", "Reporting"],
        },
        {
          tag: "03",
          name: "AEO",
          desc: "Answer Engine Optimization. We make sure ChatGPT, Perplexity and Google AI Overviews cite you, not your competitor.",
          points: ["Schema.org & entities", "LLM readability", "FAQ stacks", "Answer-first content"],
        },
        {
          tag: "04",
          name: "Meta Ads",
          desc: "Facebook & Instagram ads built to scale. Creative-first, data-driven, fully attribution-proof.",
          points: ["Creative production", "Funnel setup", "Pixel & CAPI", "Weekly optimization"],
        },
      ],
    },
    audit: {
      overline: "Free AI scan",
      title: "Scan your site in about a minute.",
      sub: "Enter a URL. I read your page the way a browser receives it, Google PageSpeed measures the speed and Claude by Anthropic explains the results. You get a personal report.",
      placeholder: "yourdomain.com",
      btn: "Analyse my site",
      loading_steps: [
        "Fetching your page…",
        "Reading robots.txt, sitemap and menu pages…",
        "Measuring speed with Google PageSpeed…",
        "Checking schema and AEO signals…",
        "Claude by Anthropic writes your report…",
      ],
      result: {
        overall: "Overall score",
        seo: "SEO",
        aeo: "AEO",
        performance: "Performance",
        findings: "Findings",
        recommendations: "Recommendations",
        aeo_ops: "AEO opportunities",
        cta: "Book a call with Ghio",
        new: "Run another scan",
        measured: "measured",
        not_measured: "not measured",
        unreadable_title: "I couldn't read your site.",
        speed_only: "What I could measure: speed",
        working: "Claude by Anthropic at work",
      },
      severity: {
        critical: "Critical",
        warning: "Warning",
        ok: "OK",
      },
      name_label: "Your name (optional)",
      email_label: "Email for the report (optional)",
      toast_complete: "Scan complete",
      toast_failed: "Scan failed",
    },
    quiz: {
      overline: "Qualification",
      title: "Which funnel fits you?",
      sub: "Five short questions. At the end you receive personalized advice.",
      start: "Start the quiz",
      next: "Next",
      back: "Back",
      submit: "Get my advice",
      step: "Step",
      of: "of",
      questions: [
        {
          id: "goal",
          q: "What is your main goal for the next 6 months?",
          options: [
            "More qualified leads",
            "Higher revenue per customer",
            "More visibility in AI search",
            "A brand new website",
          ],
        },
        {
          id: "stage",
          q: "Where are you today?",
          options: [
            "Starter — just getting going",
            "Growing — first customers in",
            "Established — ready to scale",
            "Enterprise — optimization needed",
          ],
        },
        {
          id: "budget",
          q: "Indicative monthly budget for marketing & web?",
          options: ["< €1,000", "€1,000 – €3,000", "€3,000 – €7,500", "€7,500+"],
        },
        {
          id: "pain",
          q: "Your biggest pain point right now?",
          options: [
            "No leads from the website",
            "Site is slow or outdated",
            "Invisible in ChatGPT / AI",
            "Ad costs running away",
          ],
        },
        {
          id: "timing",
          q: "When do you want to start?",
          options: ["ASAP", "Within 1 month", "Within 3 months", "Just exploring"],
        },
      ],
      form_title: "Leave your details",
      form_sub: "We'll send you personalized advice within 24 hours.",
      name: "Name",
      email: "Email",
      company: "Company",
      phone: "Phone",
      success_title: "Thank you.",
      success_sub: "Your advice will be in your inbox within 24 hours. No spam, promise.",
      toast_sent: "Sent",
      toast_error: "Something went wrong.",
    },
    nachtrust: {
      overline: "Nachtrust · Maintenance, hosting and monitoring",
      title: "If you don't hear from me, all is well.",
      sub: "Updates, backups, security and monitoring. Every day, every night. If something goes wrong, I fix it before you notice. For WordPress and for the systems I build myself.",
      tiers: [
        {
          name: "Basic",
          price: "€49",
          cycle: "/mo",
          desc: "Peace of mind for a regular business site.",
          features: [
            "Weekly core & plugin updates",
            "Daily offsite backup",
            "24/7 uptime monitoring",
            "Monthly report",
          ],
          cta: "Choose Basic",
          highlight: false,
        },
        {
          name: "Pro",
          price: "€99",
          cycle: "/mo",
          desc: "The sweet spot for growing brands.",
          features: [
            "Everything in Basic",
            "Security hardening & malware scan",
            "Performance tuning & caching",
            "30 min content/dev work per month",
            "Priority support within 4 hours",
          ],
          cta: "Choose Pro",
          highlight: true,
          badge: "Most chosen",
        },
        {
          name: "Premium",
          price: "€199",
          cycle: "/mo",
          desc: "For sites where every minute matters.",
          features: [
            "Everything in Pro",
            "Staging environment & deploy workflow",
            "1h content/dev work per month",
            "Monthly strategy call",
            "Support within 1 hour, 24/7",
          ],
          cta: "Choose Premium",
          highlight: false,
        },
      ],
      guarantee: "No contract, cancel monthly. At least 23 clients have been with me for over five years.",
    },
    work: {
      overline: "Work",
      title: "Results you can see.",
      items: [
        {
          slug: "ten-wolde-tools",
          client: "Ten Wolde Tools",
          metric: "Thousands of €",
          label: "a year in platform fees saved",
          detail: "Own webshop with 35,000+ products, linked to suppliers and till",
        },
        {
          slug: "helza-hobbyzaden",
          client: "Helza Hobbyzaden",
          metric: "20 days",
          label: "from order to live, before sowing season",
          detail: "Seed shop in 3 languages, no plugin fees",
        },
        {
          slug: "lemmer-leeft",
          client: "Lemmer Leeft",
          metric: "129",
          label: "businesses visible to visitors",
          detail: "Visitor portal in 3 languages, run by the BIZ itself",
        },
        {
          slug: "power-academy",
          client: "Power Academy",
          metric: "3 → 1",
          label: "site, checkout and members' area become one platform",
          detail: "Now in progress",
          badge: "In progress",
        },
      ],
      visit: "View project",
    },
    about: {
      overline: "About Ghio",
      title: "Entrepreneur. Builder. One point of contact.",
      body: [
        "I'm Ghio Coste. I've been building websites, webshops and platforms for twenty years. And I run a fitness studio in Lemmer myself, with members and campaigns. So I know how it feels when the site goes down on a Saturday.",
        "That's why I build what I'd want myself: a system that does exactly what your business needs. After that, I keep an eye on it.",
        "With AI as my right hand, I do alone what used to take a whole team. I check everything myself, and I stand behind it. You talk to one person, from the first sketch to the last ad.",
        "Small or large. A shop in Lemmer, a seed shop in three languages, or a platform with over 100,000 visitors a quarter.",
      ],
      stats: [
        { k: "20+", v: "years of experience" },
        { k: "280+", v: "projects live" },
        { k: "23", v: "clients with me for over 5 years" },
        { k: "4.9", v: "review score", href: "https://www.trustindex.io/reviews/ghio.nl" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's talk.",
      sub: "An idea, a brief, or just a coffee. We reply within one business day.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      company: "Company",
      message: "Tell us about your project",
      submit: "Send message",
      sending: "Sending…",
      success: "Sent. We'll be in touch soon.",
      error: "Something went wrong. Please try again later.",
    },
    footer: {
      tagline: "Website. Marketing. Automations. Handled.",
      office: "Office",
      contact: "Contact",
      legal: "Legal",
      kvk: "CoC 42040800",
      rights: "All rights reserved.",
    },
    common: {
      close: "Close",
    },
    support: {
      overline: "Remote support",
      title: "Let us take a quick look.",
      sub: "Using TeamViewer QuickSupport we briefly and securely connect to your computer — only on your invitation, and you can end the session any time.",
      step_overline: "Three steps",
      step1_title: "Download QuickSupport",
      step1_body: "Click the button for your system below. It's a small (~10 MB) tool that needs no install — it starts immediately.",
      step2_title: "Open the file",
      step2_body: "You'll see an ID and a password appear. Don't do anything else — just wait for our call.",
      step3_title: "Call or email us",
      step3_body: "Share the ID and password with us and we'll connect. Closing the window ends the session instantly.",
      download_overline: "Download",
      download_recommended: "Recommended for your system",
      download_windows: "Windows · QuickSupport (.exe)",
      download_mac: "macOS · QuickSupport (.dmg)",
      download_mobile: "iOS / Android · app store",
      download_other: "Different system? Open teamviewer.com",
      contact_overline: "Call us directly",
      contact_call: "Call +31 6 53 73 18 19",
      contact_email: "Or email info@ghio.nl",
      privacy_title: "Safe and transparent",
      privacy_body: "You share your ID yourself. We see nothing without your consent. Sessions are not recorded unless you ask. Close the window and the connection is severed.",
    },
  },
};
